"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bladeContainerClassName = void 0;
var class_name_1 = require("../../../common/view/class-name");
exports.bladeContainerClassName = (0, class_name_1.ClassName)('cnt');
